import { render } from "./ViewStockOpname.vue?vue&type=template&id=a4ca1124"
import script from "./ViewStockOpname.vue?vue&type=script&lang=js"
export * from "./ViewStockOpname.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__